import { sendRequest } from '../sendRequest';

const aichatApi = {
  aiChatNew(data) {
    return sendRequest('/api/public/ai/new', { method: 'POST', data });
  },
  aiChatEstimate(data) {
    return sendRequest('/api/public/ai/message', { method: 'POST', data });
  },
  aiChatHistory(data) {
    return sendRequest('/api/public/ai/history', { method: 'POST', data });
  },
  aiChatDelete(data) {
    return sendRequest('/api/public/ai/delete', { method: 'POST', data });
  },
  aiChatList(data) {
    return sendRequest('/api/public/ai/list', { method: 'POST', data });
  },
  aiChatSummarize(data) {
    return sendRequest('/api/public/ai/summarize', { method: 'POST', data });
  },
  aiChatConversation(data) {
    return sendRequest('/api/public/ai/estimate', { method: 'POST', data });
  },
  aiChatDocs(formData, conversationId) {
    return sendRequest(`/api/public/ai/docs?conversationId=${conversationId}`, { method: 'POST_MULTIPART', formData });
  },
  aiChatUploaded(data) {
    return sendRequest('/api/public/ai/uploaded', { method: 'POST', data });
  },
};

export default aichatApi;
